export const characters = {
  title: "Personajes",
  subtitle: "Creá y gestioná personajes para automatizar tus tareas",
  newCharacter: "Nuevo Personaje",
  noCharacters: "No se encontraron personajes",
  edit: "Editar",
  delete: "Eliminar",
  name: "Nombre",
  description: "Descripción",
  systemPrompt: "Prompt del Sistema",
  temperature: "Temperatura",
  model: "Modelo",
  tools: "Herramientas",
  create: "Crear Personaje",
  table: {
    title: "Nombre",
    description: "Descripción",
    tools: "Herramientas",
    actions: "Acciones",
    public: "Público",
    private: "Privado",
  },
  actions: {
    edit: "Editar",
    delete: "Eliminar",
    chat: "Chatear con el personaje",
  },
  profilePicture: "Foto de Perfil (URL)",
  tagline: "Lema", //  "Tagline" is often translated as "Lema" or "Eslogan".
  greeting: "Mensaje de Bienvenida",
  public: "Público",
  update: "Actualizar",
};
